import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Tick = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M9.03 18.34c-.23 0-.46-.09-.64-.26l-4.07-4.07a.9.9 0 0 1 0-1.27.9.9 0 0 1 1.27 0l3.43 3.43L18.4 6.8a.9.9 0 0 1 1.27 0 .9.9 0 0 1 0 1.27l-10 10c-.18.18-.41.26-.64.26v.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Tick
